import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'

import { AnnotatedMap } from 'components/AnnotatedMap'
import { GetAnnotations } from 'components/Localization/Annotations'
import { ChartFrame } from 'components/ChartFrame'
import { useWindowSize } from 'usehooks-ts'
import { Melting } from 'components/Melting'
import { SizeCompare } from 'components/SizeCompare'
import { Flooding } from 'components/Flooding'

declare global {
  interface Window {
    scrollytarget: any
  }
}

window.scrollytarget = window.scrollytarget || 0
const lang: 'de' | 'fr' = 'de'
const dev = window.document.title === 'TA-Interaktiv Microfrontend'
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const visualization = properties?.visualization

  const { width, height } = useWindowSize()
  const [size, setSize] = useState({ width, height })

  useEffect(() => {
    setSize({ width, height: window.innerHeight })
  }, [])

  useEffect(() => {
    setSize({ width, height: size.height || height })
  }, [width])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      {dev && <DevText />}{' '}
      {(visualization === 'flooding' || dev) && (
        <ChartFrame id='size'>
          <TextWidth>
            <div className='title'>
              Diese Gebiete werden bei einem Meeresspiegelanstieg überfluted
            </div>
          </TextWidth>
          <Flooding lang={tenant?.lang} colorMode={colorMode} />
        </ChartFrame>
      )}
      {dev && <DevText />}{' '}
      {(visualization === 'size' || dev) && (
        <ChartFrame id='size'>
          <TextWidth>
            <SizeCompare lang={tenant?.lang} colorMode={colorMode} />
          </TextWidth>
        </ChartFrame>
      )}
      {dev && <DevText />}{' '}
      {(visualization === 'melting' || dev) && (
        <ChartFrame id='melting' overflowHidden>
          <TextWidth>
            <Melting lang={tenant?.lang} />
          </TextWidth>
        </ChartFrame>
      )}
      {dev && <DevText />}
      {(visualization === 'overview' || dev) && (
        <ChartFrame id='overview'>
          <AnnotatedMap
            image={require('../Assets/overview.png')}
            annotations={GetAnnotations(lang, 'overview')}
            screenHeight
            windowSize={size}
          />
        </ChartFrame>
      )}
      {dev && <DevText />}
      {(visualization === 'landmass' || dev) && (
        <ChartFrame id='landmass'>
          <TextWidth>
            <div className='title'>Landmasse der Antarktis</div>
          </TextWidth>
          <AnnotatedMap
            image={require('../Assets/landwasser.png')}
            annotations={GetAnnotations(lang, 'landmass')}
            screenHeight
            windowSize={size}
          />
        </ChartFrame>
      )}
      {dev && <DevText />}
    </AppContainer>
  )
}
const AppContainer = styled.div`
  margin: 0;
  padding: 0;
  font-family: var(--font-noto);
  font-size: 1.8rem;
  line-height: 3rem;
  max-width: 100%;
  #back {
    overflow-x: hidden;
  }
`
export default MainComponent

const DevText = () => (
  <TextWidth>
    Der Grund, dass das Wasser unter dem Thwaites-Gletscher eine derart
    verheerende Wirkung hat, liegt an zwei Besonderheiten. Erstens befinden sich
    weite Teile des westantarktischen Eises unter dem Meeresspiegel – das Eis
    liegt mit der Unterseite also auf dem Meeresboden auf. Deshalb spricht man
    hier genaugenommen auch nicht nur von einem Eisschild, wie wir weiter oben
    behauptet haben. Man spricht von einem marinen Eisschild.46 Das heisst,
    schmilzt dieses Eis dereinst komplett ab, bleibt als Landfläche ausser ein
    paar Inseln nichts zurück.
  </TextWidth>
)
